import { BoatGallery } from '@components/BoatGallery';
import { BoatIcon } from '@icons';
import styles from '@styles/SingleBoat/boat_overview.module.scss';
import { Col, Grid, Row } from 'antd';
import Link from 'next/link';
import React from 'react';
import { UploadFile, UploadFileRelationResponseCollection } from 'services/graphql/cms';

type Props = {
  boatName: string;
  image: UploadFile;
  files: UploadFile[];
  menuItems: {
    title: string;
    desc: string | string[] | number | JSX.Element;
    path?: string | string[];
  }[];
};

const BoatOverview: React.FC<Props> = ({ boatName, image, files, menuItems }) => {
  const { useBreakpoint } = Grid;
  const { md } = useBreakpoint();

  return (
    <div className={styles.container}>
      <Row gutter={md ? 24 : 0}>
        <Col md={12} sm={24} className={styles.containerImage}>
          <BoatGallery boatName={boatName} files={files} image={image} />
        </Col>

        <Col md={12} sm={24} xs={24}>
          <div className={styles.containerContent}>
            <h4 className={styles.contentTitle}>
              <BoatIcon />
              Boat Overview
            </h4>

            <ul className={styles.contentMenu}>
              {menuItems.map((item) => {
                const { title: boatTitle, desc, path } = item;

                return (
                  <li className={styles.menuItem} key={item.title}>
                    {boatTitle ? <h5 className={styles.itemTitle}>{boatTitle}</h5> : null}
                    {Array.isArray(desc) ? (
                      desc?.map((item, index) => (
                        <div key={index} className={styles.itemDesc}>
                          <Link href={Array.isArray(path) ? path[index] : path} className={styles.itemLinkStyles}>
                            {item}
                          </Link>
                        </div>
                      ))
                    ) : path ? (
                      <div className={styles.itemDesc}>
                        <Link href={Array.isArray(path) ? path[0] : path} className={styles.itemLinkStyles}>
                          {desc}
                        </Link>
                      </div>
                    ) : (
                      <h6 className={styles.itemDesc}>{desc || '-'}</h6>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BoatOverview;
